import { CSSProperties } from 'react';
import { LabelType } from '../types/labels';

export function Label({ label }: { label: LabelType }): React.ReactNode {
  const style: CSSProperties = { color: label.textColor };
  if (label.color) {
    style.backgroundColor = label.color;
  }
  return (
    <div
      style={style}
      className="w-fit text-marker-xs h-[18px] px-[6px] 768:h-[20px] 768:px-[8px] flex justify-center items-center"
    >
      <div className="leading-[100%]">{label.text}</div>
    </div>
  );
}
